"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const aws_amplify_1 = __importDefault(require("aws-amplify"));
let _defaultUserAgent = null;
const _shortUrlTokens = {};
let _token = '';
let _baseUrl = null;
let _debugId = 0;
let _cognitoConfiguration;
function setDefaultUserAgent(application, version) {
    _defaultUserAgent = `${application}/${version}`;
}
function getDefaultUserAgent() {
    return _defaultUserAgent;
}
function setShortUrlToken(id, token) {
    _shortUrlTokens[id] = token;
}
function getShortUrlToken(id) {
    return _shortUrlTokens[id];
}
function setBaseUrl(baseUrl) {
    _baseUrl = baseUrl;
}
function getBaseUrl() {
    return _baseUrl;
}
function setDebugMode(debug) {
    _debugId = debug ? 1 : 0;
}
function getDebugId() {
    if (_debugId) {
        _debugId += 1;
        return _debugId;
    }
    return 0;
}
function setAuthorizationToken(token) {
    _token = token;
}
function getAuthorizationToken() {
    return _token;
}
let _getRequestController;
function setRequestControllerFactory(getRequestController) {
    _getRequestController = getRequestController;
}
function getRequestController(
// eslint complains about RequestInit
// eslint-disable-next-line no-undef
options) {
    return _getRequestController === null || _getRequestController === void 0 ? void 0 : _getRequestController(options);
}
/**
 * Configure attributes in the API package and also trigger idempotent side-effects such as configuring the Amplify instance.
 */
function configure({ cognitoConfigParams, oauthConfigParams, baseUrl, ssr, authTokenProvider, }) {
    _baseUrl = baseUrl;
    _cognitoConfiguration = Object.assign(Object.assign({}, cognitoConfigParams), { userPoolWebClientId: oauthConfigParams.clientId, oauth: oauthConfigParams, authTokenProvider });
    aws_amplify_1.default.configure({
        Auth: _cognitoConfiguration,
        ssr,
    });
}
const getAuthConfiguration = () => _cognitoConfiguration;
exports.config = {
    configure,
    getAuthConfiguration,
    setDefaultUserAgent,
    getDefaultUserAgent,
    getBaseUrl,
    setBaseUrl,
    setShortUrlToken,
    getShortUrlToken,
    setDebugMode,
    getDebugId,
    setAuthorizationToken,
    getAuthorizationToken,
    setRequestControllerFactory,
    getRequestController,
};
//# sourceMappingURL=config.js.map